import * as React from 'react';
import { Button } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import OAuth, { OAuthClientStatus } from '../api';

interface ButtonState {
    changePending: boolean;
}

// tslint:disable-next-line:interface-name
interface IState {
    scan: ButtonState;
    schedule: ButtonState;
}

// tslint:disable-next-line:interface-name
interface IProps {
    className?: string;
    scan?: boolean;
    schedule?: boolean;
}

const ControlEndpoints = {
    scan: 'scanning',
    schedule: 'schedule/daily'
};

export default class ScanScheduleControl extends React.Component<IProps, IState> {
    public static defaultProps: Partial<IProps> = {
        className: 'ScanScheduleControl',
        scan: false,
        schedule: false
    };

    componentWillMount() {
        this.setState({
            scan: {
                changePending: false
            },
            schedule: {
                changePending: false
            }
        });
    }

    public render() {
        const { scan, schedule } = this.state;
        return (
            <OAuth.Context>{ (oauth: OAuthClientStatus) => {
                const { level, sys } = oauth;
                const isAdmin = level === 'admin';
                const isNotLiveMode = sys.interface !== 'live';
                return isAdmin
                ? <React.Fragment>
                        <Button
                            className={this.buttonClassName(sys.schedule.active)}
                            disabled={isNotLiveMode || schedule.changePending}
                            onClick={() => this.controlOperation('schedule', ControlEndpoints.schedule, sys.schedule.active )}
                        >
                            {this.buttonText('Schedule', sys.schedule.active)}
                        </Button>
                        <Button
                            className={this.buttonClassName(sys.scanning.active)}
                            disabled={isNotLiveMode || scan.changePending}
                            onClick={() => this.controlOperation('scan', ControlEndpoints.scan, sys.scanning.active )}
                        >
                            {this.buttonText('Scan', sys.scanning.active)}
                        </Button>
                   </React.Fragment>
                : null;
            }}
            </OAuth.Context>
        );
    }

    private controlOperation(buttonId: string, endpoint: string, active: boolean) {
        let param = active                            // deduce control operation verb from current button state
            ? 'stop'
            : 'start';

        // this function updates the button state
        const updateButtonState = (buttonState: any) =>
            this.setState((prevState: IState) => ({ ...prevState, [buttonId]: {...buttonState} }) );

        // indicate the button is in a pending state
        updateButtonState({ changePending: true });

        // perform the control request
        let url = 'http://default/api/' + endpoint + '/' + param;
        axios.post(
            url,
        )
            .then((resp: AxiosResponse) => {
                if (resp.data !== undefined && resp.data.code === 'SUCCESS' ) {
                    // toggle the state, remove pending state of button
                    // perform immediate update of sys status
                    const { oauth, key } = OAuth.getContextFromResponseObject(resp);
                    if (oauth)
                        oauth.queryStatus(key)
                            .then((sys) => {
                                this.setState({
                                    scan: {
                                        // active: scanning.active,
                                        changePending: false
                                    },
                                    schedule: {
                                        // active: schedule.active,
                                        changePending: false
                                    }
                                });
                            });
                } else {
                    // tslint:disable-next-line:no-console
                    console.log('failed to ' + param + ' ' + buttonId + ': error ', resp.data);
                }

            })
            .catch(function (err: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('failed to ' + param + ' ' + buttonId + ': error ', err);
            });
    }

    private buttonClassName(active: boolean) {
        return active
            ? 'rightButton-active'
            : 'rightButton';
    }

    private buttonText(buttonName: string, active: boolean) {
        // notice the Start/Stop is the reverse of active state since the button shows the action, not current state
        return active
            ? 'Stop ' + buttonName
            : 'Start ' + buttonName;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/sys/ScanScheduleControl.tsx